export default {
  CPQ: {
    "button.createQuote": "Create quote",
    "dialog.confirm.genericDelete.subtitle":
      "Do you really want to delete this item?",
    "opportunity.title": "Opportunity",
    "opportunity.heading": "Opportunity {{name}} {{id}}",
    "cart.title": "Cart",
    "button.addQuote": "Add quote",
    "button.addLineItem": "New line item",
    "dialog.addLineItem.title": "New line item",
    "button.presets": "Presets",
    "button.upload": "Upload",
    "button.archive": "Archiv",
    "button.createOpportunity": "Create opportunity",
    "button.cancel": "Cancel",
    "button.save": "Ok",
    "button.reset": "Reset",
    "button.confirm": "Ok",
    "button.goToCatalog": "Go to catalog",
    "button.inventoryDocumentation": "Inventory documentation",
    "button.download": "Download",
    "button.start": "Start",
    "button.logout": "Logout",
    "button.addCustomProduct": "Custom product",
    "button.addProduct": "Product",
    "button.addFilter": "Add filter",
    "button.delete": "Delete",
    "select.language": "Language",
    "dialog.createOpportunity.subtitle": "Create a new opportunity",
    "dialog.updateOpportunity.title": "Edit opportunity",
    "dialog.updateOpportunity.subtitle": "Adjust an existing opportunity",
    "button.footer.backToOverview": "Back to overview",
    "button.footer.saveAndExit": "Save and exit",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Set status manually",
    "button.footer.generateDocument": "Generate document",
    "button.preview": "Preview",
    "button.footer.backToConfiguration": "Back to configuration",
    "button.addConfigurableProduct": "Add configurable product",
    "buttons.addConfigurationToItemGroupsButtonSelect.label": "Add to quote",
    "button.unarchiveOpportunity": "restore",
    "button.archiveOpportunity": "archive",
    "button.addItemGroup": "New group",
    "button.updateItemGroup": "Edit",
    "dialog.createCustomer.title": "Create customer",
    "dialog.createCustomer.subtitle": "Create a new customer",
    "dialog.createCompany.title": "Create company",
    "dialog.createCompany.subtitle": "Create a new company",
    "dialog.addLineItem.input.label.lineItemName": "Line item name",
    "dialog.createOpportunity.input.label.opportunityName": "Name",
    "dialog.createOpportunity.input.label.customer": "Customer",
    "dialog.createOpportunity.input.label.zipCode": "Zip code",
    "dialog.createOpportunity.input.label.city": "City",
    "dialog.createOpportunity.input.label.description": "Description",
    "dialog.createOpportunity.title": "New Opportunity",
    "dialog.createOpportunity.input.validFrom.label": "Valid from",
    "dialog.createOpportunity.input.validTo.label": "Valid to",
    "dialog.configuratorMode.title": "Create new quote",
    "dialog.configuratorMode.option.configurator.title": "Configuration",
    "dialog.configuratorMode.option.configurator.description":
      "Overall system configuration",
    "dialog.configuratorMode.option.expressMode.title": "Express Mode",
    "dialog.configuratorMode.option.expressMode.description":
      "Single item order",
    "dialog.configuratorMode.description": "Choose your preferred mode",
    "dialog.confirm.unarchiveQuote.title": "Restore quote",
    "dialog.confirm.unarchiveQuote.description":
      "Do you really want to restore this quote?",
    "dialog.confirm.archiveQuote.title": "Archive quote",
    "dialog.confirm.archiveQuote.description":
      "Do you really want to archive this quote?",
    "dialog.confirm.unarchiveOpportunity.title": "Restore opportunity",
    "dialog.confirm.unarchiveOpportunity.description":
      "Do you really want to restore this opportunity?",
    "dialog.confirm.archiveOpportunity.title": "Archive opportunity",
    "dialog.confirm.archiveOpportunity.description":
      "Do you really want to archive this opportunity?",
    "dialog.confirm.setOptional.title": "Set optional",
    "dialog.confirm.unsetOptional.title": "Unset optional",
    "dialog.confirm.setOptional.subtitle":
      "Do you really want to set this item as optional?",
    "dialog.confirm.unsetOptional.subtitle":
      "Do you really want to unset this item as optional?",
    "dialog.confirm.genericDelete.title": "Delete",
    "dialog.addProducts.title.addProduct": "Select products",
    "dialog.addItemGroup.title": "New group",
    "dialog.addItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateItemGroup.title": "Edit group",
    "dialog.updateItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateLineItem.title": "Edit line item",
    "dialog.updateLineItem.input.label.itemGroupName": "Line item name",
    "dialog.updateDefault.title": "Edit",
    "dialog.updateDefault.input.label.name": "Name",
    "dialog.addCustomProduct.title": "Add custom product",
    "dialog.addCustomProduct.identifier": "Identifier",
    "dialog.addCustomProduct.partId": "Article number",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Description",
    "dialog.addCustomProduct.customer": "Customer",
    "dialog.addCustomProduct.productTypeId": "Product Type",
    "dialog.addCustomProduct.productStateId": "Product State",
    "dialog.addCustomProduct.isShared": "Shared product",
    "dialog.addCustomProduct.isActive": "Active",
    "breadcrumb.opportunities": "Opportunities",
    "breadcrumb.quotes": "Quotes",
    "breadcrumb.itemGroups": "Item Groups",
    "breadcrumb.archive": "Archive",
    "breadcrumb.configurator": "Configurator",
    "breadcrumb.expressMode": "Express mode",
    "breadcrumb.lineItems": "Line item",
    "breadcrumb.overview": "Overview",
    "breadcrumb.catalog": "Catalog",
    "breadcrumb.salesQuotationView": "Sales quotation view",
    "breadcrumb.summaryView": "Summary view",
    "breadcrumb.ManagementView": "Management view",
    "breadcrumb.quoteInfo": "Quote info",
    "breadcrumb.texts": "Texts",
    "breadcrumb.documentGeneration": "Document generation",
    "header.opportunity": "Opportunity",
    "header.opportunities": "Opportunities",
    "header.quoteDetails": "Quote",
    "header.itemGroupDetails": "Item Group",
    "header.archive": "Archive",
    "header.configurator": "Configurator",
    "header.expressMode": "Express mode",
    "header.lineItemDetails": "Line item",
    "header.presets": "Presets",
    "dropZone.label": "Drag & drop or browse",
    "dropZone.isDragActive.label": "Drop here",
    "fileUpload.label": "Stock images",
    "filters.input.label.identifier": "Name",
    "filters.input.label.zipCode": "Zip code",
    "filters.input.label.city": "City",
    "filters.input.label.customer": "Customer",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Search",
    "quote.property.label.uniqueNumberString": "Quote number",
    "quote.property.label.name": "Name",
    "quote.property.label.description": "Description",
    "quote.property.label.region": "Region",
    "quote.property.label.revision": "Revision number",
    "quote.property.label.createdBy": "Created by",
    "quote.property.label.customer": "Customer",
    "quote.property.label.lastUpdatedOn": "Last updated on",
    "quote.property.label.lastUpdatedBy": "Last updated by",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Group",
    "itemGroup.name": "Group Name",
    "table.actions.deleteRow": "Delete",
    "table.lineItems.header.articleNumber": "Article number",
    "table.lineItems.header.partId": "Part ID",
    "table.lineItems.header.name": "Name",
    "table.lineItems.header.identifier": "Identifier",
    "table.lineItems.header.productIdentifier": "Product identifier",
    "table.lineItems.header.description": "Description",
    "table.lineItems.header.quantity": "Quantity",
    "table.lineItems.header.actions": "Actions",
    "table.lineItems.header.optional": "Optional",
    "table.lineItems.header.company": "Company",
    "table.lineItems.actions.cloneRow": "Duplicate",
    "table.lineItems.actions.deleteRow": "Delete",
    "table.lineItems.actions.showBOM": "Show BOM",
    "table.lineItems.actions.showSummary": "Show Summary",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Preview",
    "catalog.productTable.header.articleNumber": "Article number",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Description",
    "catalog.productTable.header.cost": "cost",
    "catalog.productTable.header.totalCost": "Total cost",
    "catalog.productTable.header.listPrice": "List price",
    "catalog.productTable.header.actions": "Quantity",
    "catalog.productTable.header.createdByName": "Created by",
    "catalog.productTable.header.createdOn": "Created On",
    "catalog.productTable.header.lastUpdatedOn": "Last updated on",
    "catalog.productTable.header.lastUpdatedByName": "Last updated by",
    "catalog.productTable.buttons.addProductToGroup": "Add",
    "catalog.productTable.buttons.addAllProductsToGroup": "Add all",
    "catalog.productTable.menu.addLineItemToNewGroup": "Create new group",
    "catalog.buttons.showLineItems": "Show line items",
    "catalog.buttons.columnsSelection": "Columns",
    "buttons.toggleSideView.label": "Sideview",
    "product.types.tooltip.Configurable": "Configurable",
    "product.types.tooltip.NonConfigurable": "Non configurable",
    "product.types.tooltip.PreConfigured": "Preconfigured",
    "product.types.tooltip.configurationStatus.toConfigure": "To be configured",
    "product.types.tooltip.configurationStatus.complete":
      "Configuration is complete",
    "product.types.tooltip.configurationStatus.incomplete":
      "Configuration is incomplete",
    "product.status.text.toConfigure": "Configure",
    "product.status.text.complete": "Configured",
    "product.status.text.incomplete": "Edit",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Categories",
    "relatedProducts.title": "Related products",
    "relatedProducts.noProducts": "No products",
    "alternativeProducts.title": "Alternative products",
    "table.itemGroups.title": "Project",
    "table.itemGroups.header.rank": "Rank",
    "table.itemGroups.header.moveRow": "Move row",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Description",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Managing entity (ME)",
    "table.itemGroups.header.priceList": "Price list",
    "table.itemGroups.header.supportingEntity": "Supporting entity (SE)",
    "table.itemGroups.header.qty": "Quantity",
    "table.itemGroups.header.itemCost": "Item cost",
    "table.itemGroups.header.costListPricing": "Cost+/List-pricing",
    "table.itemGroups.header.markup": "Markup",
    "table.itemGroups.header.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.header.itemList": "Item list",
    "table.itemGroups.header.totalList": "Total List",
    "table.itemGroups.header.discount": "Discount",
    "table.itemGroups.header.discount2": "Discount 2",
    "table.itemGroups.header.discount3": "Discount 3",
    "table.itemGroups.header.discount4": "Discount 4",
    "table.itemGroups.header.totalDiscount": "Total discount",
    "table.itemGroups.input.label.markup": "Markup",
    "table.itemGroups.input.label.discount": "Discount",
    "table.itemGroups.input.label.discount2": "Discount 2",
    "table.itemGroups.input.label.discount3": "Discount 3",
    "table.itemGroups.input.label.discount4": "Discount 4",
    "table.itemGroups.input.label.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.input.label.discountPercentage": "Discount (%)",
    "table.itemGroups.input.label.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.input.label.serviceDiscountPercentage": "Discount 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Discount 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Discount 4 (%)",
    "table.itemGroups.header.discountPercentage": "Discount (%)",
    "table.itemGroups.header.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Total discount (%)",
    "table.itemGroups.header.totalNet": "Total Net",
    "table.itemGroups.header.margin": "Gross Margin",
    "table.itemGroups.header.cost": "Cost",
    "table.itemGroups.header.actions": "Actions",
    "table.itemGroups.header.totalCost": "Total cost",
    "table.itemGroups.header.listPrice": "List price",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Shared products",
    "categories.customProducts": "Custom products",
    "catalog.productTable.buttons.addProductToLineItem": "Add to Line Item",
    "catalog.productTable.buttons.addAllProductsToLineItem":
      "Add all to Line Item",
    "catalog.productTable.buttons.addProductsToQuote": "Add to Quote",
    "catalog.productTable.buttons.addAllProductsToQuote": "Add all to Quote",
    "quote.buttons.exportToExcel": "Export",
    "catalog.selectACategoryFirst": "Select a category first",
    "button.import": "Import",
    "dialog.importExcel.title": "Import Excel",
    "dialog.createQuote.title": "Create quote",
    "dialog.createQuote.subtitle": "Create a new quote",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Description",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Customer",
    "dialog.updateQuote.title": "Edit quote",
    "dialog.updateQuote.subtitle": "Adjust an existing quote",
    "button.uploadGeneric.placeholder": "Upload file",
    "checkbox.import.label.override": "Check here to override existing entries",
    priceListSelectLabel: "Price list",
    currencySelectLabel: "Currency",
    "button.goBackToOpportunities": "Back to opportunities",
    "button.goBackToOpportunity": "Back to opportunity",
    "button.goBackToQuote": "Back to quote",
    "item.property.label.note": "Customer position / asset position",
    "item.property.label.listPrice": "List price",
    "item.property.label.totalList": "Total list price",
    "item.property.label.discount": "Discount",
    "item.property.label.totalDiscount": "Total discount",
    "item.property.label.totalCost": "Total cost",
    "item.property.label.totalNet": "Total net price",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Article number",
    "item.property.label.description": "Description",
    "item.property.label.quantity": "Quantity",
    "subItem.property.label.totalList": "List",
    "subItem.property.label.totalCost": "Cost",
    "subItem.property.label.totalNet": "Net",
    "lineItems.bom.label": "Bill of materials",
    "priceSummary.totalCost": "Total cost",
    "priceSummary.totalList": "Total list",
    "priceSummary.totalNet": "Total net",
    "dialog.requestQuote.title": "Send request",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Do you want to proceed?",
    "priceList.select.confirm.subtitle":
      "Changing the price list at this level will overwrite all price lists at lower levels.",
    "toast.error.unknown": "An error occurred",
    "toast.success.itemWasAddedToQuote": "Item was added to quote",
    "toast.success.groupCreated": "The group was created",
    "toast.success.groupWithItemsCreated":
      "The group was created and Items were added",
    "toast.success.itemWasAddedToCart": "Item was added to the cart",
    "form.field.label.customerNumber": "Customer Number",
    "form.field.label.companyName": "Company Name",
    "form.field.label.company": "Company",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Salutation",
    "form.field.label.contactTitle": "Title",
    "form.field.label.contactFirstName": "Name",
    "form.field.label.contactLastName": "Last Name",
    "form.field.label.street": "Street",
    "form.field.label.streetNumber": "Number",
    "form.field.label.postalCode": "Postal Code",
    "form.field.label.town": "Town",
    "form.field.label.country": "Country",
    "form.field.label.emailAddress": "Email",
    "form.field.label.phoneNumber": "Phone",
    "form.field.label.mobileNumber": "Mobile",
    "form.field.label.companyId": "Company",
    "form.field.label.description": "Description",
    "form.field.error.email": "Email address is not valid",
    "quoteInfo.buttons.addNewCustomer": "Add new customer",
    "quoteInfo.buttons.addNewCompany": "Add new company",
    "quoteInfo.buttons.addNewSalesLocation": "Add new sales",
    "quoteInfo.buttons.assignSalesLocation": "Assign",
    "quoteInfo.buttons.assignCustomer": "Assign customer",
    "quoteInfo.buttons.save": "Assign customer",
    "quoteInfo.general.header": "General information",
    "quoteInfo.general.quoteId": "Quote id",
    "quoteInfo.general.quote.uniqueNumberString": "Quote number",
    "quoteInfo.general.opportunity.uniqueNumberString": "Opportunity number",
    "quoteInfo.general.currency": "Currency",
    "quoteInfo.general.createdByName": "Created by",
    "quoteInfo.general.quoteCreationDate": "Quote creation date",
    "quoteInfo.general.lastUpdatedByName": "Last updated by",
    "quoteInfo.general.lastUpdatedOn": "Last updated on",
    "quoteInfo.salesLocation.header": "Sales",
    "quoteInfo.customer.header": "Customer",
    "quoteInfo.customer.customerNumber": "Customer number",
    "quoteInfo.customer.companyName": "Company name",
    "quoteInfo.customer.contactSalutation": "Salutation",
    "quoteInfo.customer.contactFirstName": "First name",
    "quoteInfo.customer.contactLastName": "Last name",
    "quoteInfo.customer.contactTitle": "Title",
    "quoteInfo.customer.street": "Street",
    "quoteInfo.customer.streetNumber": "Street number",
    "quoteInfo.customer.postalCode": "Postal code",
    "quoteInfo.customer.town": "Town",
    "quoteInfo.customer.country": "Country",
    "quoteInfo.customer.emailAddress": "Email",
    "quoteInfo.customer.phoneNumber": "Phone number",
    "quoteInfo.customer.mobileNumber": "Mobile number",
    "dialog.createSalesLocation.title": "Create sales location",
    "dialog.createSalesLocation.subtitle": "Create a new sales location",
    "quoteInfo.customer.salesLocations.header": "Sales",
    "quoteInfo.customer.salesLocations.salesLocationName":
      "Sales locations name",
    "quoteInfo.customer.salesLocations.contactTitle": "Title",
    "quoteInfo.customer.salesLocations.contactSalutation": "Salutation",
    "quoteInfo.customer.salesLocations.contactFirstName": "First name",
    "quoteInfo.customer.salesLocations.contactLastName": "Last name",
    "quoteInfo.customer.salesLocations.street": "Street",
    "quoteInfo.customer.salesLocations.streetNumber": "Street number",
    "quoteInfo.customer.salesLocations.postalCode": "Postal code",
    "quoteInfo.customer.salesLocations.town": "Town",
    "quoteInfo.customer.salesLocations.country": "Country",
    "quoteInfo.customer.salesLocations.emailAddress": "Email",
    "quoteInfo.customer.salesLocations.phoneNumber": "Phone number",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobile number",
    "dialog.addCustomProduct.priceCost.value": "Value",
    "dialog.addCustomProduct.priceCost.validFrom": "Valid from",
    "dialog.addCustomProduct.priceCost.validTo": "Valid to",
    "dialog.addCustomProduct.price": "Price",
    "dialog.addCustomProduct.cost": "Cost",
    "productDetails.partId": "Article number",
    "productDetails.listPrice": "List price",
    "productDetails.cost": "Cost",
    "searchField.label": "Search",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Discount exceeds limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Product is in use and cannot be deleted",
    "filter.filterAttributeInput.label": "Attribute",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Value",
    "filter.button.applyFilter": "Apply",
    "filter.button.clearAllFilter": "Clear all",
    "toast.error.filterAlreadyPresent": "Filter already present",
    "selectionBanner.text": "{{selectedProducts}} products selected",
    "selectionBanner.clearSelection.text": "clear selection",
    "cart.label.emptyCart": "Your cart is empty",
    "cart.button.addConfiguration": "Add configuration",
    "cart.button.addArticle": "Add article",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Subtotal",
    "cart.summary.totalNet.label": "Total net",
    "cart.summary.button.requestQuote": "Request Quote",
    "cart.summary.button.proceedToCheckout": "Proceed to Checkout",
    "quotes.table.uniqueNumberString": "Number",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Last updated",
    "quotes.table.creationDate": "Creation date",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Search",
    "infotext.userNotLoggedIn": "Not logged in",
    "buttons.save": "Save",
    "buttons.reset": "Reset",
    "quotes.table.toolbar.filters.status": "Status",
    "iconButton.download": "Download",
    "iconButton.clone": "Duplicate",
    "iconButton.delete": "Delete",
    "drawer.showBOM.title": "Bill of materials",
    "drawer.showSummary.title": "Summary",
    "workflowSelect.title": "Please choose a Workflow",
    "workflowSelect.customer.title": "Customer",
    "workflowSelect.customer.subTitle":
      "A streamlined workflow for browsing and purchasing products.",
    "workflowSelect.sales.title": "Sales",
    "workflowSelect.sales.subTitle":
      "Configure, price and quote with an integrated catalog, tailored for sales persons.",
    "workflowSelect.projectList.title": "Project List",
    "workflowSelect.projectList.subTitle":
      "Manage articles and projects efficiently with a comprehensive list view.",
    "moveRowMenu.options.topPosition": "Top postion",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Description",
    "opportunities.quotesTable.header.customer": "Customer",
    "opportunities.quotesTable.header.quoteNumber": "Quote number",
    "opportunities.quotesTable.header.createdByName": "Created by",
    "opportunities.quotesTable.header.lastUpdatedByName": "Last updated by",
    "opportunities.quotesTable.header.lastUpdatedOn": "Last updated on",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label":
      "Includes Long Text",
    "outputOptionsSelection.checkbox.includePartId.label":
      "Includes Part Number of Articles",
    "outputOptionsSelection.checkbox.includePrices.label": "Includes Prices",
    "outputOptionsSelection.checkbox.includeDiscounts.label":
      "Includes Discounts",
  },
  translation: { DATA_SHEET: "Data Sheet" },
  WEG: {
    "appcalc.recommendation.flag": "WEG Recommendation",
    "btn.askForQuote": "Ask for Quote",
    "btn.import": "import",
    "btn.importConfigId": "Import GPS ID",
    "btn.loginToEasy": "Return to EASY",
    "btn.sendRequest": "Send Request",
    "btn.setAdministrationArea": "Access",
    "button.send": "Send",
    "button.back": "Back",
    "button.upload": "Upload",
    "buttons.addToQuote": "Add to item list",
    "buttons.backToCart": "To project list",
    "buttons.backToRoot": "To the homepage",
    "buttons.cancel": "Cancel",
    "buttons.confirm": "Confirm",
    "buttons.download": "Download",
    "buttons.ExitConfigurationButton": "Project list",
    "buttons.ExitWithoutSavingButton": "Exit",
    "buttons.header.returnToWEG": "Home",
    "buttons.header.returnToWEG.url":
      "https://www.weg.net/catalog/weg/AT/en/Gearboxes-and-Geared-Motors/c/GLOBAL_GEARBOXES",
    "buttons.header.toProjectList": "Restart configuration",
    "buttons.resetConfiguration": "Reset",
    "buttons.SaveAndExitConfigurationButton": "Save & Exit",
    "buttons.saveAsTemplate": "Save template",
    "buttons.SaveConfigurationButton": "Save Configuration",
    "buttons.AddToProjectList": "Add to project list",
    "buttons.select": "Select",
    "buttons.showAllProjects": "Show all projects",
    "cart.table.header.configurationId": "GPS ID",
    "cart.table.header.customerId": "Customer ID/ TAG Nr",
    "cart.table.header.item": "Item",
    "cart.table.header.notes": "Notes",
    "cart.table.header.quantity": "Quantity",
    "cart.table.header.syncSelect": "Sync",
    "cart.table.header.type": "Type",
    "cart.table.header.priceIndicator": "Price Indicator",
    "cart.table.header.status": "Status",
    "cartViewHeader.button.title": "New Configuration",
    "config.btn.searchProduct": "Search Product",
    "description.configurator.appCalc":
      "Size the product with data from your equipment",
    "description.configurator.productConfigurator":
      "Size your produt with drive data",
    "dialog.addToQuote.title": "Please select an article list",
    "dialog.administrationArea.header": "Location",
    "error.invalidGUID": "Invalid GPS ID",
    "error.noPOSfound": "No Points of Service found.",
    "header.cart.title": "Project list",
    "label.configId": "Config ID",
    "label.country": "Country",
    "label.form.city": "Town/City",
    "label.form.company": "Company",
    "label.form.companyName": "Company Name",
    "label.form.country": "Country",
    "label.form.email": "E-Mail",
    "label.form.formCity": "City",
    "label.form.formDistrict": "District",
    "label.form.formPurchasePlace": "Purchase Place",
    "label.form.formRegion": "Region",
    "label.form.formUserComment": "Comment",
    "label.form.name": "Name",
    "label.form.phone": "Phone",
    "label.form.phoneNumber": "Phone number",
    "label.form.street": "Street",
    "label.form.streetNr": "No.",
    "label.form.surname": "Surname",
    "label.form.userInquiry": "What is your inquiry?",
    "label.form.zipCode": "ZIP-Code",
    "latestProjects.table.header.batch": "Commission",
    "latestProjects.table.header.lastChange": "Last change",
    "latestProjects.table.header.orderNumber": "Order number",
    "latestProjects.table.header.projectName": "Project name",
    "latestProjects.table.header.projectNumber": "Project number",
    "latestProjects.table.title": "Most recent projects",
    "message.confirmSendQuoteRequest":
      "Sending this request will finalize the quote and prevent further changes.",
    "message.errorSendQuoteRequest":
      "Unfortunately the request could not be sent, please try again.",
    "message.successSendQuoteRequest":
      "We have forwarded your request to our sales department and you will receive a confirmation email shortly.",
    "modal.ExitConfiguration.note": "Warning: Unsaved changes will be lost.",
    "modal.ExitConfiguration.title": "To project list",
    "preselector.page1.linkText": "Contact us",
    "preselector.subcaption.text": "Find your Product based on your needs.",
    "products.buttons.addToQuote": "Add to item list",
    "products.buttons.configure": "Configure",
    "title.configurator.appCalc": "Application Calculator",
    "title.configurator.preselection": "Gear ProSelect",
    "title.configurator.productConfigurator": "Product Configurator",
    "title.confirmSendQuoteRequest": "Request quote",
    "title.successSendQuoteRequest": "Thank you for your request!",
    "toast.JmpToEasy.timeout": "Easy Endpoint time-out. Please try again",
    "tooltip.copyToClipboard": "Copy",
    "subconfigurationNavigation.previousItem": "Back",
    "subconfigurationNavigation.nextItem": "Next",
    "buttons.edit": "Edit",
    "response.WegStoreFinderError": "EasyApi returned status code {{params}}",
    "response.Unauthorized": "SessionId not found.",
    "response.NoQuoteFound": "No Quote found for this SessionId: {{params}}",
    "response.SomethingWentWrong": "Something went wrong: {{params}}",
    "response.NoDownloadManual": "No manual found.",
    "response.WrongInputParameters":
      "The following input parameters are required: {{params}}",
    noQuoteFound: "No Quote found for the current Session {{sessionId}}",
    noConfigurationsFound: "No selected Configurations found",
    noBaseConfigurableFound: "No BaseConfigurable found",
    noFromToCharacteristics:
      "No FromToCharacteristics found for one or more of the selected items",
    "buttons.downloadUserManual": "User Manual",
    footerCopyright: "WEG | Gear ProSelect",
    ProjectListEmptyMsg: "There are no projects",
    "error.projectList.noItems": "There are no projects",
    "error.projectList.incompleteItems": "Some projects are still incomplete",
  },
};
